export const PAGE_PATH = '/create-withdraw-gift';
